module.exports = __webpack_public_path__ + "img/riekkola_sisalta4.c9e14457.jpg";